export const GET_MANAGED_POLLS = 'GET_MANAGED_POLLS';
export const SET_MANAGED_POLLS = 'SET_MANAGED_POLLS';
export const STORE_POLL = 'STORE_POLL';
export const SET_POLL = 'SET_POLL';
export const GET_POLLS = 'GET_POLLS';
export const GET_POLL = 'GET_POLL';
export const SET_POLLS = 'SET_POLLS';
export const FILL_POLL_QUESTION = 'FILL_POLL_QUESTION';
export const GET_POLL_ANSWERS = 'GET_POLL_ANSWERS';
export const GET_POLL_RESULTS = 'GET_POLL_RESULTS';
